module.exports = __webpack_public_path__ + "media/entities/1102-7bf7c912.png";